module.exports = __webpack_public_path__ + "img/cy.c5123360.svg";